import { AttributeValueValidator } from '../../lib/attribute-value-validator/attribute-value-validator.js';
import { CrntElement } from '../../lib/crnt-element.js';
import { CrntBoxedInputMixin } from '../boxed-input/boxed-input-mixin.js';

class CrntTextInput extends CrntBoxedInputMixin(CrntElement) {
  constructor() {
    super(...arguments);
    this._inputTypeValidator = new AttributeValueValidator({
      attributeKey: "type",
      host: this,
      validValues: ["text"]
    });
  }
  static {
    this.styles = [CrntBoxedInputMixin(CrntElement).styles || []];
  }
  static {
    this.tagName = "crnt-text-input";
  }
  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    this._controls?.forEach((control) => {
      this._inputTypeValidator.validate(control.getAttribute("type"));
    });
  }
}

export { CrntTextInput };
